import React, { Component } from 'react';
import DrawableCanvas from 'react-drawable-canvas';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeMap } from '../../../actions/ts_map_actions.js';
import { updateModal } from '../../../actions/modal.js';
import { updateCanvas } from '../../../actions/ts_canvas_actions.js';
import { clearDraw } from '../../../actions/ts_overlay_actions.js';
import Promo from '../../promo/'
import {
  CSGO,
  INFERNO,
  TRAIN,
  MIRAGE,
  NUKE,
  COBBLESTONE,
  OVERPASS,
  CACHE,
} from '../../../utils/maps/types';
class CS_GO extends Component {

  constructor(props) {
      super(props);
  }

changeMap(game,map)
{
  var {overlay} = this.props;
  this.props.changeMap(game,map);
  this.props.clearDraw(overlay.color,overlay.color1,overlay.color2);
  this.props.updateModal(false,null);
  this.props.updateCanvas(null,null,[]);
}
    render() {
        return (
          <div>
                <Promo/>
                <span className="menuHeaderText">Counter-Strike<span className="smallText">®</span>: Global Offensive</span><br/><br/>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,CACHE);}}>Cache</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,COBBLESTONE);}}>Cobblestone</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,INFERNO);}}>Inferno</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,MIRAGE);}}>Mirage</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,NUKE);}}>Nuke</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,OVERPASS);}}>Overpass</button>
                <button className="mapStyle" onClick={(event) => {this.changeMap(CSGO,TRAIN);}}>Train</button>
          </div>

        );
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changeMap, clearDraw, updateModal, updateCanvas
    }, dispatch);
}

function mapStateToProps(state) {
    return { map: state.map, overlay: state.overlay, canvas: state.canvas };
}

export default connect(mapStateToProps, mapDispatchToProps)(CS_GO);



// WEBPACK FOOTER //
// ./src/app/components/menu/games/csgo.jsx